export default "/images/759348a29d148d07c5fa9b0a5698465d.avif";